module.exports = __webpack_public_path__ + "Max-Occ.png?50def6744e5327f3dd57b1fb7f27eb01";